// @flow
import type {JSONImage} from "./jsontypes.js";

export class Variant {
	url: string;
	// TODO: make sure the view code can deal with one dimension being null
	size: [number, number];
	name: string;
	// $FlowFixMe: WTF?
	constructor(url: string, size: [?number, ?number], name: string) {
		this.url = url;
		this.size = [
			size[0] || size[1] || 1,
			size[1] || size[0] || 1,
		];
		this.name = name;
	}
}

export default class Image {
	variants: Array<Variant> = [];

	constructor(json: JSONImage, baseUrl: string = "", toWebP = false, toAVIF = false) {
		if (Array.isArray(json)) {
			this.variants = json.map(({url, size, name}) => new Variant(url, size, name));
		} else {
			const url = baseUrl + json.url;
			const base = url.slice(0, url.lastIndexOf('.'));
			const ext = toAVIF ? '.avif' : toWebP ? ".webp" : url.slice(url.lastIndexOf('.'));
			const {res, size} = json;
			res.sort();
			this.variants = res.map(res => new Variant(
				res === 1 ? `${base}${ext}` : `${base}@${res}x${ext}`,
				(size || [400, 400]).map((s) => s * res)));
		}
	}
}



// WEBPACK FOOTER //
// ./lib/api/image.js